import { FC } from 'react';
import { Overlay } from '../../styles/StyledSpinner';

type Props = {
  children: React.ReactNode; 
};

export const Spinner: FC<Props> = ({ children }) => <Overlay>{children}</Overlay>;